import { render, staticRenderFns } from "./LocationsMenuItems.vue?vue&type=template&id=2f4370da&scoped=true&"
import script from "./LocationsMenuItems.vue?vue&type=script&lang=js&"
export * from "./LocationsMenuItems.vue?vue&type=script&lang=js&"
import style0 from "./LocationsMenuItems.vue?vue&type=style&index=0&id=2f4370da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4370da",
  null
  
)

export default component.exports